/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pie_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online pie chart maker. Paste labels and values to get an instant, colourful pie chart with percentages.`)
};

const es_pie_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador gratuito de gráficos circulares online. Pega etiquetas y valores para obtener un gráfico circular instantáneo y colorido con porcentajes.`)
};

const de_pie_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Kreisdiagramm-Ersteller. Fügen Sie Bezeichnungen und Werte ein und erhalten Sie sofort ein farbenfrohes Kreisdiagramm mit Prozentangaben.`)
};

const nl_pie_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online cirkeldiagrammaker. Plak labels en waarden om direct een kleurrijk cirkeldiagram met percentages te krijgen.`)
};

const fr_pie_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur gratuit de diagramme circulaire en ligne. Collez des étiquettes et des valeurs pour obtenir instantanément un diagramme circulaire coloré avec pourcentages.`)
};

const it_pie_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore gratuito di grafici a torta online. Incolla etichette e valori per ottenere un grafico a torta istantaneo e colorato con le percentuali.`)
};

const pt_br2_pie_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador gratuito online de gráfico de pizza. Cole rótulos e valores para obter um gráfico de pizza instantâneo e colorido com percentuais.`)
};

const pt_pie_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de gráficos circulares online. Cole rótulos e valores e obtenha instantaneamente um gráfico circular colorido com percentagens.`)
};

const ja_pie_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンライン円グラフ作成ツール。ラベルと値を貼り付けると、パーセンテージ付きの見やすい円グラフが即座に得られます。`)
};

const zh_pie_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线饼图制作工具。粘贴标签和数值即可获得带百分比的即时多彩饼图。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pie_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pie_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pie_meta_description", locale)
	if (locale === "en") return en_pie_meta_description(inputs)
	if (locale === "es") return es_pie_meta_description(inputs)
	if (locale === "de") return de_pie_meta_description(inputs)
	if (locale === "nl") return nl_pie_meta_description(inputs)
	if (locale === "fr") return fr_pie_meta_description(inputs)
	if (locale === "it") return it_pie_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_pie_meta_description(inputs)
	if (locale === "pt") return pt_pie_meta_description(inputs)
	if (locale === "ja") return ja_pie_meta_description(inputs)
	return zh_pie_meta_description(inputs)
};